Controller.$inject = [];

function Controller() {

}

export function HuiModalFooter() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: Controller,
        bindToController: {
            justifyContent: '@'
        },
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `<div ng-transclude class="hui-modal-footer modal-footer" ng-class="['justify-content-' + ($huiCtrl.justifyContent || 'end')]"></div>`;
        }
    }
}